import Iconify from "../../iconify";
import IconCode from "@/src/lib/iconCode";
import CustomButton from "@/src/lib/ui/Button";
const NoTestFoundInCart = ({ findTest }) => {
    return (
        <div className="max-w-60 mx-auto h-full flex items-center justify-center flex-col">
            <Iconify
                icon={IconCode.cart}
                width="60px"
                className="mx-auto pb-2"
            />
            <p className="text-black text-lg font-medium text-center leading-6">
                Looks like there are no tests in your centre visit cart
            </p>

            <CustomButton
                variant="contained"
                className="mt-3 "
                onClick={findTest}
            >
                Find a Test
            </CustomButton>
        </div>
    );
};

export default NoTestFoundInCart;
